import {GET_OFFER_LETTER_LIST, GET_OFFER_LETTER_LIST_SUCCESS,GET_OFFER_LETTER_LIST_FAILED} from './actionTypes'

export const getOfferLetterListData = (json)=>{
    return{
        type:GET_OFFER_LETTER_LIST,
        payload: {json}
    }
}

export const getOfferLetterListDataSuccess = (json)=>{
    return{
        type:GET_OFFER_LETTER_LIST_SUCCESS,
        payload: json
    }
}


export const getOfferLetterListDataFail = (json)=>{
    return{
        type: GET_OFFER_LETTER_LIST_FAILED,
        payload: json
    }
}

